const BabyPhoneDark = () => (
  <svg
    fill="none"
    height="48"
    viewBox="0 0 48 48"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4741_15755)">
      <mask
        height="44"
        id="mask0_4741_15755"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="26"
        x="4"
        y="3"
      >
        <path
          d="M22.4838 3.7297L6.95562 5.41097C5.36132 5.58553 4.20938 7.00955 4.37526 8.60813L8.25501 44.2363C8.43011 45.8257 9.85852 46.9741 11.462 46.8087L26.9902 45.1274C28.5845 44.9529 29.7365 43.5288 29.5706 41.9303L25.6816 6.30213C25.5065 4.71274 24.0781 3.56433 22.4746 3.7297H22.4838Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4741_15755)">
        <path
          d="M26.7505 46.9719L29.7363 46.6504V46.9352L29.423 46.9719H26.7505Z"
          fill="#734271"
        />
        <path
          d="M24.0872 46.9735L29.7363 46.3672V46.652L26.7505 46.9735H24.0872Z"
          fill="#744372"
        />
        <path
          d="M21.4238 46.9722L29.7363 46.0811V46.3659L24.0871 46.9722H21.4238Z"
          fill="#744473"
        />
        <path
          d="M18.7607 46.9732L29.7365 45.7881V46.0821L21.424 46.9732H18.7607Z"
          fill="#754574"
        />
        <path
          d="M16.0879 46.9719L29.7361 45.502V45.7868L18.7604 46.9719H16.0879Z"
          fill="#754775"
        />
        <path
          d="M13.4248 46.9735L29.7363 45.2188V45.5036L16.0881 46.9735H13.4248Z"
          fill="#744876"
        />
        <path
          d="M10.7615 46.9726L29.7363 44.9238V45.2178L13.4248 46.9726H10.7615Z"
          fill="#764978"
        />
        <path
          d="M8.08887 46.9732L29.7362 44.6396V44.9245L10.7614 46.9732H8.08887Z"
          fill="#764A79"
        />
        <path
          d="M6.68835 46.9719L6.66992 46.8341L29.7365 44.3535V44.6383L8.08912 46.9719H6.68835Z"
          fill="#774B7A"
        />
        <path
          d="M6.66974 46.8357L6.64209 46.5601L29.7363 44.0703V44.3551L6.66974 46.8357Z"
          fill="#774D7B"
        />
        <path
          d="M6.64215 46.5591L6.6145 46.2743L29.7363 43.7754V44.0694L6.64215 46.5591Z"
          fill="#784E7C"
        />
        <path
          d="M6.6145 46.274L6.57764 45.9892L29.7363 43.4902V43.775L6.6145 46.274Z"
          fill="#784F7D"
        />
        <path
          d="M6.57745 45.9888L6.5498 45.704L29.7361 43.2051V43.4899L6.57745 45.9888Z"
          fill="#79507E"
        />
        <path
          d="M6.54986 45.705L6.52222 45.4202L29.7362 42.9121V43.2061L6.54986 45.705Z"
          fill="#79517F"
        />
        <path
          d="M6.52221 45.4199L6.48535 45.1351L29.7362 42.627V42.9118L6.52221 45.4199Z"
          fill="#785280"
        />
        <path
          d="M6.48517 45.1357L6.45752 44.8509L29.736 42.3428V42.6276L6.48517 45.1357Z"
          fill="#7A5381"
        />
        <path
          d="M6.45782 44.8509L6.43018 44.5661L29.7363 42.0488V42.3428L6.45782 44.8509Z"
          fill="#795482"
        />
        <path
          d="M6.43017 44.5658L6.39331 44.281L29.7363 41.7637V42.0485L6.43017 44.5658Z"
          fill="#7A5683"
        />
        <path
          d="M6.39337 44.2806L6.36572 43.9958L29.7364 41.4785V41.7633L6.39337 44.2806Z"
          fill="#7A5684"
        />
        <path
          d="M6.36554 43.9964L6.33789 43.7116L29.7362 41.1943V41.4791L6.36554 43.9964Z"
          fill="#7B5784"
        />
        <path
          d="M6.33789 43.7117L6.30103 43.4269L29.7362 40.9004V41.1944L6.33789 43.7117Z"
          fill="#7B5986"
        />
        <path
          d="M6.30108 43.4256L6.27344 43.1408L29.7362 40.6143V40.8991L6.30108 43.4256Z"
          fill="#7A5A86"
        />
        <path
          d="M6.27325 43.1414L6.24561 42.8566L29.7361 40.3301V40.6149L6.27325 43.1414Z"
          fill="#7B5B87"
        />
        <path
          d="M6.24585 42.8556L6.20898 42.58L29.7363 40.0352V40.3292L6.24585 42.8556Z"
          fill="#7B5C88"
        />
        <path
          d="M6.2088 42.5816L6.18115 42.2968L29.7361 39.752V40.0368L6.2088 42.5816Z"
          fill="#7C5D89"
        />
        <path
          d="M6.18139 42.2965L6.14453 42.0117L29.7364 39.4668V39.7516L6.18139 42.2965Z"
          fill="#7C5E8A"
        />
        <path
          d="M6.14435 42.0113L6.1167 41.7265L29.7362 39.1816V39.4664L6.14435 42.0113Z"
          fill="#7D5F8B"
        />
        <path
          d="M6.11676 41.7256L6.08911 41.4408L29.7362 38.8867V39.1807L6.11676 41.7256Z"
          fill="#7D608C"
        />
        <path
          d="M6.08911 41.4424L6.05225 41.1576L29.7362 38.6035V38.8883L6.08911 41.4424Z"
          fill="#7F618D"
        />
        <path
          d="M6.0523 41.1572L6.02466 40.8724L29.7363 38.3184V38.6032L6.0523 41.1572Z"
          fill="#7E638E"
        />
        <path
          d="M6.02472 40.8725L5.99707 40.5877L29.7363 38.0244V38.3184L6.02472 40.8725Z"
          fill="#7E648F"
        />
        <path
          d="M5.99682 40.5883L5.95996 40.3035L29.7361 37.7402V38.025L5.99682 40.5883Z"
          fill="#7E6490"
        />
        <path
          d="M5.96026 40.3031L5.93262 40.0183L29.7364 37.4551V37.7399L5.96026 40.3031Z"
          fill="#7F6691"
        />
        <path
          d="M5.93268 40.0174L5.90503 39.7326L29.7365 37.1602V37.4541L5.93268 40.0174Z"
          fill="#7F6792"
        />
        <path
          d="M5.90478 39.7332L5.86792 39.4484L29.7362 36.876V37.1608L5.90478 39.7332Z"
          fill="#7F6893"
        />
        <path
          d="M5.86798 39.4471L5.84033 39.1623L29.7363 36.5898V36.8746L5.86798 39.4471Z"
          fill="#806994"
        />
        <path
          d="M5.84039 39.1639L5.81274 38.8791L29.7363 36.3066V36.5914L5.84039 39.1639Z"
          fill="#7F6A94"
        />
        <path
          d="M5.81274 38.8801L5.77588 38.5953L29.7363 36.0137V36.3077L5.81274 38.8801Z"
          fill="#806B96"
        />
        <path
          d="M5.77569 38.594L5.74805 38.3183L29.7361 35.7275V36.0123L5.77569 38.594Z"
          fill="#806C96"
        />
        <path
          d="M5.74835 38.319L5.7207 38.0342L29.7364 35.4434V35.7282L5.74835 38.319Z"
          fill="#806D97"
        />
        <path
          d="M5.72046 38.0332L5.68359 37.7484L29.7362 35.1484V35.4424L5.72046 38.0332Z"
          fill="#816E99"
        />
        <path
          d="M5.68365 37.7481L5.65601 37.4633L29.7363 34.8633V35.1481L5.68365 37.7481Z"
          fill="#81709A"
        />
        <path
          d="M5.65606 37.4639L5.62842 37.1791L29.7363 34.5791V34.8639L5.65606 37.4639Z"
          fill="#81709A"
        />
        <path
          d="M5.62841 37.1791L5.59155 36.8943L29.7363 34.2852V34.5791L5.62841 37.1791Z"
          fill="#81719B"
        />
        <path
          d="M5.59161 36.894L5.56396 36.6092L29.7364 34V34.2848L5.59161 36.894Z"
          fill="#83739D"
        />
        <path
          d="M5.56378 36.6088L5.53613 36.324L29.7362 33.7148V33.9996L5.56378 36.6088Z"
          fill="#83749D"
        />
        <path
          d="M5.53637 36.3246L5.49951 36.0398L29.7364 33.4307V33.7155L5.53637 36.3246Z"
          fill="#82759F"
        />
        <path
          d="M5.49933 36.0399L5.47168 35.7551L29.7362 33.1367V33.4307L5.49933 36.0399Z"
          fill="#83769F"
        />
        <path
          d="M5.47149 35.7547L5.44385 35.4699L29.7361 32.8516V33.1364L5.47149 35.7547Z"
          fill="#8377A1"
        />
        <path
          d="M5.44409 35.4696L5.40723 35.1848L29.7363 32.5664V32.8512L5.44409 35.4696Z"
          fill="#8578A2"
        />
        <path
          d="M5.40729 35.1858L5.37964 34.901L29.7364 32.2734V32.5674L5.40729 35.1858Z"
          fill="#8479A3"
        />
        <path
          d="M5.37964 34.9006L5.34277 34.6158L29.7364 31.9883V32.2731L5.37964 34.9006Z"
          fill="#857AA4"
        />
        <path
          d="M5.34259 34.6155L5.31494 34.3307L29.7362 31.7031V31.9879L5.34259 34.6155Z"
          fill="#857BA4"
        />
        <path
          d="M5.315 34.3323L5.28735 34.0567L29.7362 31.4199V31.7047L5.315 34.3323Z"
          fill="#857CA5"
        />
        <path
          d="M5.28735 34.0557L5.25049 33.7709L29.7362 31.125V31.419L5.28735 34.0557Z"
          fill="#867DA6"
        />
        <path
          d="M5.2503 33.7706L5.22266 33.4858L29.736 30.8398V31.1246L5.2503 33.7706Z"
          fill="#867EA7"
        />
        <path
          d="M5.22296 33.4854L5.19531 33.2006L29.7363 30.5547V30.8395L5.22296 33.4854Z"
          fill="#867FA8"
        />
        <path
          d="M5.19531 33.2007L5.15845 32.9159L29.7363 30.2607V30.5547L5.19531 33.2007Z"
          fill="#8680A9"
        />
        <path
          d="M5.15851 32.9165L5.13086 32.6317L29.7364 29.9766V30.2614L5.15851 32.9165Z"
          fill="#8780AA"
        />
        <path
          d="M5.13067 32.6323L5.10303 32.3475L29.7362 29.6924V29.9772L5.13067 32.6323Z"
          fill="#8682AB"
        />
        <path
          d="M5.10327 32.3456L5.06641 32.0608L29.7365 29.3965V29.6905L5.10327 32.3456Z"
          fill="#8883AC"
        />
        <path
          d="M5.06622 32.0614L5.03857 31.7766L29.7363 29.1123V29.3971L5.06622 32.0614Z"
          fill="#8884AD"
        />
        <path
          d="M5.03839 31.7772L5.01074 31.4924L29.7361 28.8281V29.1129L5.03839 31.7772Z"
          fill="#8785AE"
        />
        <path
          d="M5.01098 31.4921L4.97412 31.2073L29.7363 28.543V28.8278L5.01098 31.4921Z"
          fill="#8886AF"
        />
        <path
          d="M4.97394 31.2083L4.94629 30.9235L29.7361 28.25V28.544L4.97394 31.2083Z"
          fill="#8887B0"
        />
        <path
          d="M4.94659 30.9222L4.91895 30.6374L29.7364 27.9639V28.2487L4.94659 30.9222Z"
          fill="#8988B0"
        />
        <path
          d="M4.9187 30.638L4.88184 30.3532L29.7362 27.6797V27.9645L4.9187 30.638Z"
          fill="#8889B2"
        />
        <path
          d="M4.88189 30.3522L4.85425 30.0674L29.7362 27.3848V27.6788L4.88189 30.3522Z"
          fill="#8A8BB3"
        />
        <path
          d="M4.85431 30.069L4.82666 29.7934L29.7363 27.1016V27.3864L4.85431 30.069Z"
          fill="#898BB4"
        />
        <path
          d="M4.82666 29.7921L4.78979 29.5073L29.7363 26.8154V27.1002L4.82666 29.7921Z"
          fill="#8A8CB5"
        />
        <path
          d="M4.78961 29.5079L4.76196 29.2231L29.7361 26.5312V26.8161L4.78961 29.5079Z"
          fill="#8A8EB5"
        />
        <path
          d="M4.76202 29.2222L4.73438 28.9374L29.7085 26.2363L29.7362 26.4293V26.5303L4.76202 29.2222Z"
          fill="#8A8FB6"
        />
        <path
          d="M29.6859 25.9557L4.70068 28.6484L4.73139 28.9316L29.7166 26.2389L29.6859 25.9557Z"
          fill="#8A90B7"
        />
        <path
          d="M29.6554 25.6745L4.67017 28.3672L4.70087 28.6503L29.6861 25.9576L29.6554 25.6745Z"
          fill="#8A91B8"
        />
        <path
          d="M29.6156 25.3854L4.63037 28.0781L4.66108 28.3613L29.6463 25.6685L29.6156 25.3854Z"
          fill="#8C92B9"
        />
        <path
          d="M29.5944 25.1061L4.60913 27.7988L4.63984 28.082L29.6251 25.3893L29.5944 25.1061Z"
          fill="#8B92BA"
        />
        <path
          d="M29.5639 24.8151L4.57861 27.5078L4.60932 27.791L29.5946 25.0982L29.5639 24.8151Z"
          fill="#8C94BB"
        />
        <path
          d="M29.5241 24.5377L4.53882 27.2305L4.56952 27.5136L29.5548 24.8209L29.5241 24.5377Z"
          fill="#8C94BB"
        />
        <path
          d="M29.5028 24.2467L4.51758 26.9395L4.54828 27.2226L29.5335 24.5299L29.5028 24.2467Z"
          fill="#8C95BC"
        />
        <path
          d="M29.4733 23.9772L4.48804 26.6699L4.51874 26.9531L29.504 24.2603L29.4733 23.9772Z"
          fill="#8C96BD"
        />
        <path
          d="M29.4335 23.6881L4.44824 26.3809L4.47895 26.664L29.4642 23.9713L29.4335 23.6881Z"
          fill="#8C98BE"
        />
        <path
          d="M29.403 23.4079L4.41772 26.1006L4.44843 26.3837L29.4337 23.691L29.403 23.4079Z"
          fill="#8D98BF"
        />
        <path
          d="M29.3817 23.1198L4.39648 25.8125L4.42719 26.0957L29.4124 23.4029L29.3817 23.1198Z"
          fill="#8C9AC0"
        />
        <path
          d="M29.3422 22.8307L4.35693 25.5234L4.38764 25.8066L29.3729 23.1139L29.3422 22.8307Z"
          fill="#8D9AC1"
        />
        <path
          d="M29.3114 22.5495L4.32617 25.2422L4.35688 25.5253L29.3421 22.8326L29.3114 22.5495Z"
          fill="#8D9BC2"
        />
        <path
          d="M29.2809 22.2623L4.29565 24.9551L4.32636 25.2382L29.3116 22.5455L29.2809 22.2623Z"
          fill="#8E9DC3"
        />
        <path
          d="M29.2504 21.9811L4.26514 24.6738L4.29584 24.957L29.2811 22.2643L29.2504 21.9811Z"
          fill="#8E9DC3"
        />
        <path
          d="M29.2199 21.692L4.23462 24.3848L4.26532 24.6679L29.2506 21.9752L29.2199 21.692Z"
          fill="#8E9EC4"
        />
        <path
          d="M29.1894 21.4127L4.2041 24.1055L4.23481 24.3886L29.2201 21.6959L29.1894 21.4127Z"
          fill="#8F9FC5"
        />
        <path
          d="M4.20898 24.1056V24.0964V23.8208L29.1555 21.1289L29.1924 21.4137L4.20898 24.1056Z"
          fill="#8EA0C6"
        />
        <path
          d="M4.20898 23.5274L29.1278 20.8447L29.1555 21.1295L4.20898 23.8214V23.5274Z"
          fill="#8FA1C7"
        />
        <path
          d="M4.20898 23.2413L29.1002 20.5586L29.1278 20.8434L4.20898 23.5261V23.2413Z"
          fill="#8FA1C8"
        />
        <path
          d="M4.20898 22.9581L29.0633 20.2754L29.1002 20.5602L4.20898 23.2429V22.9581Z"
          fill="#91A2C9"
        />
        <path
          d="M4.20898 22.6627L29.0357 19.9893L29.0633 20.2741L4.20898 22.9567V22.6627Z"
          fill="#90A4CA"
        />
        <path
          d="M4.20898 22.3786L29.008 19.7051L29.0357 19.9899L4.20898 22.6634V22.3786Z"
          fill="#91A5CB"
        />
        <path
          d="M4.20898 22.0944L28.9712 19.4209L29.008 19.7057L4.20898 22.3792V22.0944Z"
          fill="#91A6CB"
        />
        <path
          d="M4.20898 21.8083L28.9435 19.1348L28.9712 19.4196L4.20898 22.0931V21.8083Z"
          fill="#91A7CC"
        />
        <path
          d="M4.20898 21.5159L28.9067 18.8516L28.9435 19.1364L4.20898 21.8099V21.5159Z"
          fill="#91A8CD"
        />
        <path
          d="M4.20898 21.2297L28.879 18.5654L28.9067 18.8502L4.20898 21.5145V21.2297Z"
          fill="#91A9CE"
        />
        <path
          d="M4.20898 20.9456L28.8514 18.2812L28.879 18.5661L4.20898 21.2304V20.9456Z"
          fill="#93ABD0"
        />
        <path
          d="M4.20898 20.6522L28.8145 17.9971L28.8514 18.2819L4.20898 20.9462V20.6522Z"
          fill="#93ACD1"
        />
        <path
          d="M4.20898 20.3666L28.7869 17.7207L28.8145 17.9963L4.20898 20.6514V20.3666Z"
          fill="#94ADD2"
        />
        <path
          d="M4.20898 20.0815L28.7592 17.4355L28.7869 17.7204L4.20898 20.3663V20.0815Z"
          fill="#94ADD2"
        />
        <path
          d="M4.20898 19.7871L28.7224 17.1504L28.7592 17.4352L4.20898 20.0811V19.7871Z"
          fill="#93AFD4"
        />
        <path
          d="M4.20898 19.5029L28.6947 16.8662L28.7224 17.151L4.20898 19.7878V19.5029Z"
          fill="#94AFD4"
        />
        <path
          d="M4.20898 19.2188L28.6671 16.582L28.6947 16.8668L4.20898 19.5036V19.2188Z"
          fill="#94B0D5"
        />
        <path
          d="M4.20898 18.9336L28.6302 16.2969L28.6671 16.5817L4.20898 19.2184V18.9336Z"
          fill="#95B1D6"
        />
        <path
          d="M4.20898 18.6393L28.6026 16.0117L28.6302 16.2965L4.20898 18.9333V18.6393Z"
          fill="#94B2D7"
        />
        <path
          d="M4.20898 18.3541L28.5749 15.7266L28.6026 16.0114L4.20898 18.6389V18.3541Z"
          fill="#96B2D7"
        />
        <path
          d="M4.20898 18.0699L28.5381 15.4424L28.5749 15.7272L4.20898 18.3547V18.0699Z"
          fill="#95B4D8"
        />
        <path
          d="M4.20898 17.7766L28.5104 15.1582L28.5381 15.443L4.20898 18.0706V17.7766Z"
          fill="#96B5D9"
        />
        <path
          d="M4.20898 17.4914L28.4828 14.873L28.5104 15.1579L4.20898 17.7762V17.4914Z"
          fill="#96B6DA"
        />
        <path
          d="M4.20898 17.2053L28.4459 14.5869L28.4828 14.8717L4.20898 17.4901V17.2053Z"
          fill="#96B7DB"
        />
        <path
          d="M4.20898 16.9211L28.4182 14.3027L28.4459 14.5875L4.20898 17.2059V16.9211Z"
          fill="#97B7DC"
        />
        <path
          d="M4.20898 16.6277L28.3906 14.0186L28.4183 14.3034L4.20898 16.9217V16.6277Z"
          fill="#96B9DD"
        />
        <path
          d="M4.20898 16.3416L28.3537 13.7324L28.3906 14.0172L4.20898 16.6264V16.3416Z"
          fill="#97B9DD"
        />
        <path
          d="M4.20898 16.057L28.3261 13.457L28.3537 13.7326L4.20898 16.3418V16.057Z"
          fill="#97BADE"
        />
        <path
          d="M4.20898 15.7646L28.2985 13.1738L28.3261 13.4586L4.20898 16.0586V15.7646Z"
          fill="#98BBDF"
        />
        <path
          d="M4.20898 15.4785L28.2616 12.8877L28.2984 13.1725L4.20898 15.7633V15.4785Z"
          fill="#99BCDF"
        />
        <path
          d="M4.20898 15.1943L28.2339 12.6035L28.2616 12.8883L4.20898 15.4791V15.1943Z"
          fill="#9ABDE0"
        />
        <path
          d="M4.20898 14.901L28.2063 12.3193L28.2339 12.6041L4.20898 15.1949V14.901Z"
          fill="#99BEE2"
        />
        <path
          d="M4.20898 14.6148L28.1694 12.0332L28.2063 12.318L4.20898 14.8996V14.6148Z"
          fill="#99BFE2"
        />
        <path
          d="M4.20898 14.3297L28.1418 11.748L28.1694 12.0329L4.20898 14.6145V14.3297Z"
          fill="#9AC0E3"
        />
        <path
          d="M4.20898 14.0455L28.1141 11.4639L28.1418 11.7487L4.20898 14.3303V14.0455Z"
          fill="#99C1E4"
        />
        <path
          d="M4.20898 13.7521L28.0773 11.1797L28.1141 11.4645L4.20898 14.0461V13.7521Z"
          fill="#99C2E6"
        />
        <path
          d="M4.20898 13.467L28.0496 10.8945L28.0773 11.1793L4.20898 13.7518V13.467Z"
          fill="#99C2E7"
        />
        <path
          d="M4.20898 13.1818L28.0128 10.6094L28.0496 10.8942L4.20898 13.4666V13.1818Z"
          fill="#9AC3E7"
        />
        <path
          d="M4.20898 12.8875L27.9851 10.3242L28.0128 10.609L4.20898 13.1815V12.8875Z"
          fill="#99C5E9"
        />
        <path
          d="M4.20898 12.6033L27.9575 10.04L27.9851 10.3248L4.20898 12.8881V12.6033Z"
          fill="#99C6EA"
        />
        <path
          d="M4.20898 12.3171L27.9206 9.75391L27.9575 10.0387L4.20898 12.602V12.3171Z"
          fill="#9AC6EA"
        />
        <path
          d="M4.20898 12.0339L27.893 9.4707L27.9206 9.75551L4.20898 12.3187V12.0339Z"
          fill="#9AC7EB"
        />
        <path
          d="M4.20898 11.7402L27.8653 9.19531L27.893 9.47093L4.20898 12.0342V11.7402Z"
          fill="#9BC8EC"
        />
        <path
          d="M4.20898 11.454L27.8285 8.90918L27.8653 9.19398L4.20898 11.7389V11.454Z"
          fill="#9BC9EC"
        />
        <path
          d="M4.20898 11.1699L27.8008 8.625L27.8285 8.9098L4.20898 11.4547V11.1699Z"
          fill="#9CCAED"
        />
        <path
          d="M4.20898 10.8765L27.7732 8.34082L27.8008 8.62562L4.20898 11.1705V10.8765Z"
          fill="#9CCBED"
        />
        <path
          d="M4.20898 10.5904L27.7363 8.05469L27.7732 8.33949L4.20898 10.8752V10.5904Z"
          fill="#9DCCEE"
        />
        <path
          d="M4.20898 10.3072L27.7087 7.77148L27.7363 8.05629L4.20898 10.592V10.3072Z"
          fill="#9DCCEE"
        />
        <path
          d="M4.20898 10.0118L27.681 7.48535L27.7087 7.77016L4.20898 10.3058V10.0118Z"
          fill="#9CCDEE"
        />
        <path
          d="M4.20898 9.72766L27.6441 7.20117L27.681 7.48598L4.20898 10.0125V9.72766Z"
          fill="#9CCEEF"
        />
        <path
          d="M4.20898 9.44348L27.6165 6.91699L27.6441 7.2018L4.20898 9.72829V9.44348Z"
          fill="#9CCEEF"
        />
        <path
          d="M4.20898 9.15735L27.5889 6.63086L27.6165 6.91566L4.20898 9.44216V9.15735Z"
          fill="#9ECFF0"
        />
        <path
          d="M4.20898 8.86301L27.552 6.3457L27.5889 6.63051L4.20898 9.157V8.86301Z"
          fill="#9ED0F0"
        />
        <path
          d="M4.20898 8.57883L27.5243 6.06152L27.552 6.34633L4.20898 8.86363V8.57883Z"
          fill="#9FD1F1"
        />
        <path
          d="M4.20898 8.29465L27.4967 5.77734L27.5243 6.06215L4.20898 8.57945V8.29465Z"
          fill="#9FD2F1"
        />
        <path
          d="M4.20898 8.00031L27.4598 5.49219L27.4967 5.77699L4.20898 8.2943V8.00031Z"
          fill="#9FD3F2"
        />
        <path
          d="M4.20898 7.71515L27.4322 5.20703L27.4598 5.49184L4.20898 7.99995V7.71515Z"
          fill="#A0D4F3"
        />
        <path
          d="M4.20898 7.43057L27.4045 4.93164L27.4322 5.20726L4.20898 7.71538V7.43057Z"
          fill="#A1D5F3"
        />
        <path
          d="M4.20898 7.13623L27.3677 4.64648L27.4045 4.93129L4.20898 7.43022V7.13623Z"
          fill="#A2D6F4"
        />
        <path
          d="M4.20898 6.85205L27.34 4.3623L27.3677 4.64711L4.20898 7.13685V6.85205Z"
          fill="#A2D7F4"
        />
        <path
          d="M4.20898 6.56787L27.3124 4.07812L27.34 4.36293L4.20898 6.85267V6.56787Z"
          fill="#A3D8F5"
        />
        <path
          d="M4.20898 6.28271L27.2755 3.79297L27.3124 4.07777L4.20898 6.56752V6.28271Z"
          fill="#A3D9F5"
        />
        <path
          d="M4.20898 5.98833L26.7687 3.55371H27.2479L27.2755 3.79258L4.20898 6.28232V5.98833Z"
          fill="#A4D9F6"
        />
        <path
          d="M4.20898 5.70353L24.1054 3.55371H26.7687L4.20898 5.98833V5.70353Z"
          fill="#A4DAF6"
        />
        <path
          d="M24.1054 3.55371L4.20898 5.70353V3.55371H24.1054Z"
          fill="#A4DAF6"
        />
      </g>
      <mask
        height="13"
        id="mask1_4741_15755"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="16"
        x="8"
        y="17"
      >
        <path
          d="M23.7735 21.1577C23.7735 21.4333 23.7459 21.7089 23.709 21.9662C23.6721 22.1683 23.6445 22.3704 23.5984 22.5633C23.3772 23.4729 22.9717 24.2905 22.4465 25.0623C22.3267 25.246 22.1884 25.4206 22.0502 25.5859C21.912 25.7697 21.7553 25.9534 21.6078 26.128C21.5986 26.1372 21.5802 26.1556 21.571 26.1647C20.3269 27.5888 18.8247 28.7188 17.212 29.7018C15.4242 29.0863 13.7193 28.3054 12.1895 27.1753C10.6229 26.0177 9.36958 24.6305 8.93645 22.646C8.63234 21.2404 9.09312 19.752 10.1898 18.8149C10.8349 18.2637 11.5537 17.9605 12.3093 17.887C12.3554 17.887 12.4199 17.887 12.466 17.8778C12.6964 17.8778 12.9176 17.8779 13.148 17.9054C13.3046 17.9238 13.4613 17.9513 13.6272 17.9881C13.7838 18.0248 13.9313 18.0708 14.0879 18.1167C15.0095 18.4291 15.6546 19.0538 16.143 19.8531C16.5393 18.6863 17.2673 17.7676 18.6865 17.3082C19.7371 16.9683 20.8982 17.0786 21.8659 17.6298C23.1929 18.3923 23.8011 19.6051 23.7735 21.1301V21.1577Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_4741_15755)">
        <path
          d="M8.63232 28.498L16.7697 29.7016H8.63232V28.498Z"
          fill="#F26D52"
        />
        <path
          d="M8.63232 28.4336L17.1659 29.7014H16.7697L8.63232 28.4979V28.4336Z"
          fill="#F26D52"
        />
        <path
          d="M8.63232 28.3789L17.5622 29.7019H17.1659L8.63232 28.434V28.3789Z"
          fill="#F36E53"
        />
        <path
          d="M8.63232 28.3223L17.9493 29.7004H17.5622L8.63232 28.3774V28.3223Z"
          fill="#F36E54"
        />
        <path
          d="M8.63232 28.2598L18.3455 29.7022H17.9493L8.63232 28.3241V28.2598Z"
          fill="#F37055"
        />
        <path
          d="M8.63232 28.2041L18.7418 29.7016H18.3455L8.63232 28.2592V28.2041Z"
          fill="#F37057"
        />
        <path
          d="M8.63232 28.1484L19.1381 29.7011H18.7418L8.63232 28.2036V28.1484Z"
          fill="#F37157"
        />
        <path
          d="M8.63232 28.0859L19.5251 29.7029H19.1381L8.63232 28.1502V28.0859Z"
          fill="#F37258"
        />
        <path
          d="M8.63232 28.0293L19.9214 29.7014H19.5251L8.63232 28.0844V28.0293Z"
          fill="#F3725A"
        />
        <path
          d="M8.63232 27.9746L20.3177 29.7018H19.9214L8.63232 28.0297V27.9746Z"
          fill="#F3735B"
        />
        <path
          d="M8.63232 27.9102L20.7139 29.7017H20.3177L8.63232 27.9745V27.9102Z"
          fill="#F3735C"
        />
        <path
          d="M8.63232 27.8555L21.1102 29.7021H20.7139L8.63232 27.9106V27.8555Z"
          fill="#F3755D"
        />
        <path
          d="M8.63232 27.791L21.4972 29.702H21.1102L8.63232 27.8553V27.791Z"
          fill="#F3745D"
        />
        <path
          d="M8.63232 27.7354L21.8935 29.7014H21.4972L8.63232 27.7905V27.7354Z"
          fill="#F3755F"
        />
        <path
          d="M8.63232 27.6797L22.2898 29.7009H21.8935L8.63232 27.7348V27.6797Z"
          fill="#F37660"
        />
        <path
          d="M8.63232 27.6172L22.686 29.7027H22.2898L8.63232 27.6815V27.6172Z"
          fill="#F37661"
        />
        <path
          d="M8.63232 27.5605L23.0731 29.7012H22.686L8.63232 27.6157V27.5605Z"
          fill="#F37762"
        />
        <path
          d="M8.63232 27.5059L23.4694 29.7016H23.0731L8.63232 27.561V27.5059Z"
          fill="#F37763"
        />
        <path
          d="M8.63232 27.4414L23.8011 29.6923V29.7015H23.4694L8.63232 27.5057V27.4414Z"
          fill="#F37864"
        />
        <path
          d="M8.63232 27.3867L23.8011 29.6376V29.6927L8.63232 27.4418V27.3867Z"
          fill="#F37965"
        />
        <path
          d="M8.63232 27.3223L23.8011 29.5731V29.6375L8.63232 27.3866V27.3223Z"
          fill="#F37966"
        />
        <path
          d="M8.63232 27.2666L23.8011 29.5175V29.5726L8.63232 27.3217V27.2666Z"
          fill="#F37968"
        />
        <path
          d="M8.63232 27.2129L23.8011 29.4638V29.5189L8.63232 27.268V27.2129Z"
          fill="#F37969"
        />
        <path
          d="M8.63232 27.1484L23.8011 29.3993V29.4636L8.63232 27.2127V27.1484Z"
          fill="#F47A6A"
        />
        <path
          d="M8.63232 27.0918L23.8011 29.3427V29.3978L8.63232 27.1469V27.0918Z"
          fill="#F37A6B"
        />
        <path
          d="M8.63232 27.0371L23.8011 29.288V29.3431L8.63232 27.0922V27.0371Z"
          fill="#F47C6C"
        />
        <path
          d="M8.63232 26.9736L23.8011 29.2245V29.2888L8.63232 27.0379V26.9736Z"
          fill="#F47C6D"
        />
        <path
          d="M8.63232 26.918L23.8011 29.1688V29.224L8.63232 26.9731V26.918Z"
          fill="#F47C6D"
        />
        <path
          d="M8.63232 26.8535L23.8011 29.1136V29.1687L8.63232 26.9178V26.8535Z"
          fill="#F47E6E"
        />
        <path
          d="M8.63232 26.7979L23.8011 29.0487V29.113L8.63232 26.853V26.7979Z"
          fill="#F47E6F"
        />
        <path
          d="M8.63232 26.7441L23.8011 28.995V29.0501L8.63232 26.7993V26.7441Z"
          fill="#F47F71"
        />
        <path
          d="M8.63232 26.6797L23.8011 28.9306V28.9949L8.63232 26.744V26.6797Z"
          fill="#F48172"
        />
        <path
          d="M8.63232 26.623L23.8011 28.8739V28.929L8.63232 26.6782V26.623Z"
          fill="#F48073"
        />
        <path
          d="M8.63232 26.5684L23.8011 28.8192V28.8744L8.63232 26.6235V26.5684Z"
          fill="#F48275"
        />
        <path
          d="M8.63232 26.5049L23.8011 28.7558V28.8201L8.63232 26.5692V26.5049Z"
          fill="#F48276"
        />
        <path
          d="M8.63232 26.4492L23.8011 28.7001V28.7552L8.63232 26.5043V26.4492Z"
          fill="#F48377"
        />
        <path
          d="M8.63232 26.3936L23.8011 28.6444V28.6996L8.63232 26.4487V26.3936Z"
          fill="#F48478"
        />
        <path
          d="M8.63232 26.3291L23.8011 28.58V28.6443L8.63232 26.3934V26.3291Z"
          fill="#F48479"
        />
        <path
          d="M8.63232 26.2754L23.8011 28.5263V28.5814L8.63232 26.3305V26.2754Z"
          fill="#F4857A"
        />
        <path
          d="M8.63232 26.2109L23.8011 28.4618V28.5261L8.63232 26.2752V26.2109Z"
          fill="#F4857B"
        />
        <path
          d="M8.63232 26.1543L23.8011 28.4052V28.4603L8.63232 26.2094V26.1543Z"
          fill="#F4867C"
        />
        <path
          d="M8.63232 26.1006L23.8011 28.3515V28.4066L8.63232 26.1557V26.1006Z"
          fill="#F4867D"
        />
        <path
          d="M8.63232 26.0361L23.8011 28.287V28.3513L8.63232 26.1004V26.0361Z"
          fill="#F5887F"
        />
        <path
          d="M8.63232 25.9805L23.8011 28.2313V28.2865L8.63232 26.0356V25.9805Z"
          fill="#F5897F"
        />
        <path
          d="M8.63232 25.9248L23.8011 28.1757V28.2308L8.63232 25.9799V25.9248Z"
          fill="#F58980"
        />
        <path
          d="M8.63232 25.8613L23.8011 28.1122V28.1765L8.63232 25.9256V25.8613Z"
          fill="#F58981"
        />
        <path
          d="M8.63232 25.8066L23.8011 28.0575V28.1126L8.63232 25.8618V25.8066Z"
          fill="#F58982"
        />
        <path
          d="M8.63232 25.7422L23.8011 28.0022V28.0574L8.63232 25.8065V25.7422Z"
          fill="#F58B84"
        />
        <path
          d="M8.63232 25.6855L23.8011 27.9364V28.0007L8.63232 25.7407V25.6855Z"
          fill="#F58C85"
        />
        <path
          d="M8.63232 25.6318L23.8011 27.8827V27.9378L8.63232 25.687V25.6318Z"
          fill="#F58C86"
        />
        <path
          d="M8.63232 25.5674L23.8011 27.8183V27.8826L8.63232 25.6317V25.5674Z"
          fill="#F58C87"
        />
        <path
          d="M8.63232 25.5117L23.8011 27.7626V27.8177L8.63232 25.5668V25.5117Z"
          fill="#F58C88"
        />
        <path
          d="M8.63232 25.4561L23.8011 27.7069V27.7621L8.63232 25.5112V25.4561Z"
          fill="#F58E89"
        />
        <path
          d="M8.63232 25.3926L23.8011 27.6435V27.7078L8.63232 25.4569V25.3926Z"
          fill="#F58E8A"
        />
        <path
          d="M8.63232 25.3379L23.8011 27.5888V27.6439L8.63232 25.393V25.3379Z"
          fill="#F58F8A"
        />
        <path
          d="M8.63232 25.2832L23.8011 27.5341V27.5892L8.63232 25.3383V25.2832Z"
          fill="#F58F8B"
        />
        <path
          d="M8.63232 25.2188L23.8011 27.4696V27.5339L8.63232 25.2831V25.2188Z"
          fill="#F58F8C"
        />
        <path
          d="M8.63232 25.1631L23.8011 27.414V27.4691L8.63232 25.2182V25.1631Z"
          fill="#F5918D"
        />
        <path
          d="M8.63232 25.0986L23.8011 27.3495V27.4138L8.63232 25.1629V25.0986Z"
          fill="#F5918F"
        />
        <path
          d="M8.63232 25.043L23.8011 27.2938V27.349L8.63232 25.0981V25.043Z"
          fill="#F5928F"
        />
        <path
          d="M8.63232 24.9883L23.8011 27.2392V27.2943L8.63232 25.0434V24.9883Z"
          fill="#F59290"
        />
        <path
          d="M8.63232 24.9238L23.8011 27.1747V27.239L8.63232 24.9881V24.9238Z"
          fill="#F59291"
        />
        <path
          d="M8.63232 24.8691L23.8011 27.12V27.1751L8.63232 24.9243V24.8691Z"
          fill="#F59393"
        />
        <path
          d="M8.63232 24.8125L23.8011 27.0634V27.1185L8.63232 24.8676V24.8125Z"
          fill="#F59393"
        />
        <path
          d="M8.63232 24.75L23.8011 27.0009V27.0652L8.63232 24.8143V24.75Z"
          fill="#F59594"
        />
        <path
          d="M8.63232 24.6943L23.8011 26.9452V27.0003L8.63232 24.7495V24.6943Z"
          fill="#F69595"
        />
        <path
          d="M8.63232 24.6299L23.8011 26.8808V26.9451L8.63232 24.6942V24.6299Z"
          fill="#F59596"
        />
        <path
          d="M8.63232 24.5762L23.8011 26.827V26.8822L8.63232 24.6313V24.5762Z"
          fill="#F69697"
        />
        <path
          d="M8.63232 24.5195L23.8011 26.7704V26.8255L8.63232 24.5747V24.5195Z"
          fill="#F59698"
        />
        <path
          d="M8.63232 24.4551L23.8011 26.706V26.7703L8.63232 24.5194V24.4551Z"
          fill="#F69799"
        />
        <path
          d="M8.63232 24.4004L23.8011 26.6513V26.7064L8.63232 24.4555V24.4004Z"
          fill="#F5979A"
        />
        <path
          d="M8.63232 24.3457L23.8011 26.5966V26.6517L8.63232 24.4008V24.3457Z"
          fill="#F6989C"
        />
        <path
          d="M8.63232 24.2812L23.8011 26.5321V26.5964L8.63232 24.3456V24.2812Z"
          fill="#F6999C"
        />
        <path
          d="M8.63232 24.2256L23.8011 26.4765V26.5316L8.63232 24.2807V24.2256Z"
          fill="#F6999D"
        />
        <path
          d="M8.63232 24.1621L23.8011 26.4222V26.4773L8.63232 24.2264V24.1621Z"
          fill="#F69A9E"
        />
        <path
          d="M8.63232 24.1074L23.8011 26.3583V26.4226L8.63232 24.1625V24.1074Z"
          fill="#F69A9F"
        />
        <path
          d="M8.63232 24.0508L23.8011 26.3017V26.3568L8.63232 24.1059V24.0508Z"
          fill="#F69BA0"
        />
        <path
          d="M8.63232 23.9863L23.8011 26.2372V26.3015L8.63232 24.0506V23.9863Z"
          fill="#F69CA2"
        />
        <path
          d="M8.63232 23.9316L23.8011 26.1825V26.2376L8.63232 23.9868V23.9316Z"
          fill="#F69CA3"
        />
        <path
          d="M8.63232 23.877L23.8011 26.1278V26.183L8.63232 23.9321V23.877Z"
          fill="#F69DA4"
        />
        <path
          d="M8.63232 23.8125L23.8011 26.0634V26.1277L8.63232 23.8768V23.8125Z"
          fill="#F69DA4"
        />
        <path
          d="M8.63232 23.7568L23.8011 26.0077V26.0628L8.63232 23.812V23.7568Z"
          fill="#F69EA5"
        />
        <path
          d="M8.63232 23.7031L23.8011 25.954V26.0091L8.63232 23.7582V23.7031Z"
          fill="#F69EA6"
        />
        <path
          d="M8.63232 23.6387L23.8011 25.8895V25.9539L8.63232 23.703V23.6387Z"
          fill="#F69FA7"
        />
        <path
          d="M8.63232 23.582L23.8011 25.8329V25.888L8.63232 23.6372V23.582Z"
          fill="#F6A0A8"
        />
        <path
          d="M8.63232 23.5176L23.8011 25.7685V25.8328L8.63232 23.5819V23.5176Z"
          fill="#F6A0A9"
        />
        <path
          d="M8.63232 23.4639L23.8011 25.7147V25.7699L8.63232 23.519V23.4639Z"
          fill="#F6A2AA"
        />
        <path
          d="M8.63232 23.4082L23.8011 25.6591V25.7142L8.63232 23.4633V23.4082Z"
          fill="#F6A1AB"
        />
        <path
          d="M8.63232 23.3438L23.8011 25.5946V25.6589L8.63232 23.4081V23.3438Z"
          fill="#F6A2AC"
        />
        <path
          d="M8.63232 23.2881L23.8011 25.539V25.5941L8.63232 23.3432V23.2881Z"
          fill="#F6A3AE"
        />
        <path
          d="M8.63232 23.2344L23.8011 25.4853V25.5404L8.63232 23.2895V23.2344Z"
          fill="#F6A4AE"
        />
        <path
          d="M8.63232 23.1699L23.8011 25.4208V25.4851L8.63232 23.2342V23.1699Z"
          fill="#F7A5B0"
        />
        <path
          d="M8.63232 23.1133L23.8011 25.3642V25.4193L8.63232 23.1684V23.1133Z"
          fill="#F7A5B1"
        />
        <path
          d="M8.63232 23.0508L23.8011 25.3108V25.366L8.63232 23.1151V23.0508Z"
          fill="#F7A6B2"
        />
        <path
          d="M8.63232 22.9951L23.8011 25.246V25.3103L8.63232 23.0502V22.9951Z"
          fill="#F7A7B3"
        />
        <path
          d="M8.63232 22.9395L23.8011 25.1903V25.2455L8.63232 22.9946V22.9395Z"
          fill="#F7A7B3"
        />
        <path
          d="M8.63232 22.875L23.8011 25.1259V25.1902L8.63232 22.9393V22.875Z"
          fill="#F7A8B5"
        />
        <path
          d="M8.63232 22.8203L23.8011 25.0712V25.1263L8.63232 22.8754V22.8203Z"
          fill="#F7A8B6"
        />
        <path
          d="M8.63232 22.7656L23.8011 25.0165V25.0716L8.63232 22.8207V22.7656Z"
          fill="#F7A9B7"
        />
        <path
          d="M8.63232 22.7012L23.8011 24.952V25.0164L8.63232 22.7655V22.7012Z"
          fill="#F7A9B7"
        />
        <path
          d="M8.63232 22.6445L23.8011 24.8954V24.9505L8.63232 22.6997V22.6445Z"
          fill="#F7A9B8"
        />
        <path
          d="M8.63232 22.582L23.8011 24.8421V24.8972L8.63232 22.6463V22.582Z"
          fill="#F7ABB9"
        />
        <path
          d="M8.63232 22.5264L23.8011 24.7772V24.8416L8.63232 22.5815V22.5264Z"
          fill="#F7AAB9"
        />
        <path
          d="M8.63232 22.4707L23.8011 24.7216V24.7767L8.63232 22.5258V22.4707Z"
          fill="#F7ACBB"
        />
        <path
          d="M8.63232 22.4082L23.8011 24.6591V24.7234L8.63232 22.4725V22.4082Z"
          fill="#F7ACBB"
        />
        <path
          d="M8.63232 22.3516L23.8011 24.6024V24.6576L8.63232 22.4067V22.3516Z"
          fill="#F7ACBC"
        />
        <path
          d="M8.63232 22.2969L23.8011 24.5477V24.6029L8.63232 22.352V22.2969Z"
          fill="#F7ADBD"
        />
        <path
          d="M8.63232 22.2324L23.8011 24.4833V24.5476L8.63232 22.2967V22.2324Z"
          fill="#F7ADBE"
        />
        <path
          d="M8.63232 22.1777L23.8011 24.4286V24.4837L8.63232 22.2329V22.1777Z"
          fill="#F7AFBF"
        />
        <path
          d="M8.63232 22.1221L23.8011 24.3729V24.4281L8.63232 22.1772V22.1221Z"
          fill="#F7AEC0"
        />
        <path
          d="M8.63232 22.0576L23.8011 24.3085V24.3728L8.63232 22.1219V22.0576Z"
          fill="#F7B0C2"
        />
        <path
          d="M8.63232 22.002L23.8011 24.2528V24.308L8.63232 22.0571V22.002Z"
          fill="#F7B0C2"
        />
        <path
          d="M8.63232 21.9395L23.8011 24.1903V24.2546L8.63232 22.0038V21.9395Z"
          fill="#F7B1C3"
        />
        <path
          d="M8.63232 21.8828L23.8011 24.1337V24.1888L8.63232 21.9379V21.8828Z"
          fill="#F7B1C4"
        />
        <path
          d="M8.63232 21.8281L23.8011 24.079V24.1341L8.63232 21.8832V21.8281Z"
          fill="#F7B1C5"
        />
        <path
          d="M8.63232 21.7646L23.8011 24.0155V24.0798L8.63232 21.829V21.7646Z"
          fill="#F7B2C6"
        />
        <path
          d="M8.63232 21.709L23.8011 23.9599V24.015L8.63232 21.7641V21.709Z"
          fill="#F7B2C6"
        />
        <path
          d="M8.63232 21.6533L23.8011 23.9042V23.9593L8.63232 21.7084V21.6533Z"
          fill="#F7B3C8"
        />
        <path
          d="M8.63232 21.5889L23.8011 23.8397V23.9041L8.63232 21.6532V21.5889Z"
          fill="#F7B4C9"
        />
        <path
          d="M8.63232 21.5352L23.8011 23.786V23.8412L8.63232 21.5903V21.5352Z"
          fill="#F7B4C9"
        />
        <path
          d="M8.63232 21.4707L23.8011 23.7308V23.7859L8.63232 21.535V21.4707Z"
          fill="#F7B5CA"
        />
        <path
          d="M8.63232 21.4141L23.8011 23.6649V23.7292L8.63232 21.4692V21.4141Z"
          fill="#F7B5CB"
        />
        <path
          d="M8.63232 21.3594L23.8011 23.6103V23.6654L8.63232 21.4145V21.3594Z"
          fill="#F7B6CC"
        />
        <path
          d="M8.63232 21.2959L23.8011 23.5468V23.6111L8.63232 21.3602V21.2959Z"
          fill="#F8B7CD"
        />
        <path
          d="M8.63232 21.2402L23.8011 23.4911V23.5462L8.63232 21.2954V21.2402Z"
          fill="#F7B7CE"
        />
        <path
          d="M8.63232 21.1846L23.8011 23.4354V23.4906L8.63232 21.2397V21.1846Z"
          fill="#F8B9CF"
        />
        <path
          d="M8.63232 21.1201L23.8011 23.371V23.4353L8.63232 21.1844V21.1201Z"
          fill="#F8B9CF"
        />
        <path
          d="M8.63232 21.0664L23.8011 23.3173V23.3724L8.63232 21.1215V21.0664Z"
          fill="#F8BBD1"
        />
        <path
          d="M8.63232 21.0098L23.8011 23.2606V23.3158L8.63232 21.0649V21.0098Z"
          fill="#F8BBD2"
        />
        <path
          d="M8.63232 20.9453L23.8011 23.1962V23.2605L8.63232 21.0096V20.9453Z"
          fill="#F8BBD2"
        />
        <path
          d="M8.63232 20.8916L23.8011 23.1425V23.1976L8.63232 20.9467V20.8916Z"
          fill="#F8BCD4"
        />
        <path
          d="M8.63232 20.8271L23.8011 23.078V23.1423L8.63232 20.8915V20.8271Z"
          fill="#F8BCD5"
        />
        <path
          d="M8.63232 20.7715L23.8011 23.0224V23.0775L8.63232 20.8266V20.7715Z"
          fill="#F8BDD7"
        />
        <path
          d="M8.63232 20.7158L23.8011 22.9667V23.0218L8.63232 20.7709V20.7158Z"
          fill="#F8BDD7"
        />
        <path
          d="M8.63232 20.6523L23.8011 22.9032V22.9675L8.63232 20.7167V20.6523Z"
          fill="#F8BFD8"
        />
        <path
          d="M8.63232 20.5977L23.8011 22.8485V22.9037L8.63232 20.6528V20.5977Z"
          fill="#F8C0D8"
        />
        <path
          d="M8.63232 20.541L23.8011 22.7919V22.847L8.63232 20.5961V20.541Z"
          fill="#F8C0D8"
        />
        <path
          d="M8.63232 20.4766L23.8011 22.7274V22.7917L8.63232 20.5409V20.4766Z"
          fill="#F8C0D9"
        />
        <path
          d="M8.63232 20.4229L23.8011 22.6737V22.7289L8.63232 20.478V20.4229Z"
          fill="#F8C0D9"
        />
        <path
          d="M8.63232 20.3584L23.8011 22.6185V22.6736L8.63232 20.4227V20.3584Z"
          fill="#F8C2DA"
        />
        <path
          d="M8.63232 20.3027L23.8011 22.5536V22.6179L8.63232 20.3579V20.3027Z"
          fill="#F8C2DA"
        />
        <path
          d="M8.63232 20.2471L23.8011 22.4979V22.5531L8.63232 20.3022V20.2471Z"
          fill="#F8C3DA"
        />
        <path
          d="M8.63232 20.1836L23.8011 22.4345V22.4988L8.63232 20.2479V20.1836Z"
          fill="#F9C4DB"
        />
        <path
          d="M8.63232 20.1289L23.8011 22.3798V22.4349L8.63232 20.184V20.1289Z"
          fill="#F9C4DB"
        />
        <path
          d="M8.63232 20.0723L23.8011 22.3231V22.3783L8.63232 20.1274V20.0723Z"
          fill="#F9C5DC"
        />
        <path
          d="M8.63232 20.0078L23.8011 22.2587V22.323L8.63232 20.0721V20.0078Z"
          fill="#F9C5DC"
        />
        <path
          d="M8.63232 19.9541L23.8011 22.205V22.2601L8.63232 20.0092V19.9541Z"
          fill="#F9C7DC"
        />
        <path
          d="M8.63232 19.8896L23.8011 22.1497V22.2048L8.63232 19.954V19.8896Z"
          fill="#F9C7DD"
        />
        <path
          d="M8.63232 19.834L23.8011 22.0849V22.1492L8.63232 19.8891V19.834Z"
          fill="#F9C7DD"
        />
        <path
          d="M8.63232 19.7793L23.8011 22.0302V22.0853L8.63232 19.8344V19.7793Z"
          fill="#F9C8DD"
        />
        <path
          d="M8.63232 19.7148L23.8011 21.9657V22.03L8.63232 19.7792V19.7148Z"
          fill="#F7C8DE"
        />
        <path
          d="M8.63232 19.6602L23.8011 21.911V21.9662L8.63232 19.7153V19.6602Z"
          fill="#F7C9DE"
        />
        <path
          d="M8.63232 19.6035L23.8011 21.8544V21.9095L8.63232 19.6586V19.6035Z"
          fill="#F8CBDF"
        />
        <path
          d="M8.63232 19.541L23.8011 21.7919V21.8562L8.63232 19.6053V19.541Z"
          fill="#F6CADF"
        />
        <path
          d="M8.63232 19.4854L23.8011 21.7362V21.7914L8.63232 19.5405V19.4854Z"
          fill="#F6CCE0"
        />
        <path
          d="M8.63232 19.4316L23.8011 21.6825V21.7376L8.63232 19.4868V19.4316Z"
          fill="#F6CBE0"
        />
        <path
          d="M8.63232 19.3652L23.8011 21.6161V21.6804L8.63232 19.4295V19.3652Z"
          fill="#F6CDE1"
        />
        <path
          d="M8.63232 19.3105L23.8011 21.5614V21.6165L8.63232 19.3657V19.3105Z"
          fill="#F5CCE1"
        />
        <path
          d="M8.63232 19.2461L23.8011 21.497V21.5613L8.63232 19.3104V19.2461Z"
          fill="#F5CDE1"
        />
        <path
          d="M8.63232 19.1914L23.8011 21.4423V21.4974L8.63232 19.2465V19.1914Z"
          fill="#F5CEE1"
        />
        <path
          d="M8.63232 19.1348L23.8011 21.3856V21.4408L8.63232 19.1899V19.1348Z"
          fill="#F5CEE1"
        />
        <path
          d="M8.63232 19.0723L23.8011 21.3231V21.3875L8.63232 19.1366V19.0723Z"
          fill="#F4CFE2"
        />
        <path
          d="M8.63232 19.0166L23.8011 21.2675V21.3226L8.63232 19.0717V19.0166Z"
          fill="#F4CFE2"
        />
        <path
          d="M8.63232 18.9629L23.8011 21.2138V21.2689L8.63232 19.018V18.9629Z"
          fill="#F4D0E3"
        />
        <path
          d="M8.63232 18.8984L23.8011 21.1493V21.2136L8.63232 18.9627V18.8984Z"
          fill="#F4D0E3"
        />
        <path
          d="M8.63232 18.8418L23.8011 21.0927V21.1478L8.63232 18.8969V18.8418Z"
          fill="#F3D1E4"
        />
        <path
          d="M8.63232 18.7773L23.8011 21.0374V21.0925L8.63232 18.8417V18.7773Z"
          fill="#F3D1E4"
        />
        <path
          d="M8.63232 18.7227L23.8011 20.9735V21.0378L8.63232 18.7778V18.7227Z"
          fill="#F3D1E4"
        />
        <path
          d="M8.63232 18.668L23.8011 20.9188V20.974L8.63232 18.7231V18.668Z"
          fill="#F3D3E5"
        />
        <path
          d="M8.63232 18.6035L23.8011 20.8544V20.9187L8.63232 18.6678V18.6035Z"
          fill="#F3D3E5"
        />
        <path
          d="M8.63232 18.5479L23.8011 20.7987V20.8539L8.63232 18.603V18.5479Z"
          fill="#F3D4E6"
        />
        <path
          d="M8.63232 18.4922L23.8011 20.7431V20.7982L8.63232 18.5473V18.4922Z"
          fill="#F4D5E6"
        />
        <path
          d="M8.63232 18.4297L23.8011 20.6806V20.7449L8.63232 18.494V18.4297Z"
          fill="#F2D5E6"
        />
        <path
          d="M8.63232 18.373L23.8011 20.6239V20.679L8.63232 18.4282V18.373Z"
          fill="#F3D6E7"
        />
        <path
          d="M8.63232 18.3193L23.8011 20.5702V20.6253L8.63232 18.3745V18.3193Z"
          fill="#F3D6E7"
        />
        <path
          d="M8.63232 18.2549L23.8011 20.5058V20.5701L8.63232 18.3192V18.2549Z"
          fill="#F3D6E7"
        />
        <path
          d="M23.8011 20.505L8.63232 18.2542V16.9863H23.8011V20.505Z"
          fill="#F3D6E7"
        />
      </g>
      <path
        d="M40.6845 14.8262L31.8192 20.9909C31.1556 21.4502 31.2478 22.4608 31.9758 22.8008L42.1498 27.4955C42.8963 27.8354 43.7257 27.2382 43.6335 26.4205L42.3249 15.5704C42.2327 14.7895 41.3296 14.3853 40.6845 14.8354V14.8262Z"
        fill="#56BB6C"
      />
      <path
        d="M30.0498 30.6375C24.6771 31.2438 20.7328 35.8926 20.9264 41.1936C20.9448 41.6254 21.3226 41.9378 21.7466 41.8919L26.0963 41.4049C26.4004 41.3682 26.6492 41.1201 26.6492 40.8078C26.6492 38.5477 28.3725 36.5908 30.6856 36.3244C32.8697 36.0763 34.8695 37.4269 35.5238 39.4389C35.6897 39.9442 36.1873 40.2657 36.7218 40.2106L40.749 39.7604C41.1269 39.7145 41.3849 39.3746 41.3204 39.0071C40.362 33.752 35.4501 30.0495 30.0498 30.6559V30.6375Z"
        fill="#FED7FF"
      />
      <path
        d="M26.4834 6.2086L26.9718 10.7379C27.3588 10.7655 27.6906 11.0411 27.7367 11.4361L27.8565 12.5019C28.4371 12.7132 29.0637 12.8326 29.718 12.8326C32.7223 12.8326 35.1644 10.398 35.1644 7.40294C35.1644 4.4079 32.7223 1.97328 29.718 1.97328C27.9855 1.97328 26.4465 2.78176 25.4512 4.04041C26.0041 4.61002 26.4004 5.35419 26.4926 6.19942L26.4834 6.2086Z"
        fill="#FFD43E"
      />
      <path
        d="M22.1244 26.7605C22.1244 26.7605 22.1981 26.687 22.2258 26.6594C22.3916 26.4665 22.5575 26.2735 22.6865 26.0898C22.834 25.9061 22.9814 25.7131 23.1197 25.511C23.7555 24.5923 24.1702 23.6827 24.3914 22.7365C24.4375 22.5343 24.4744 22.3138 24.5112 22.075C24.5481 21.781 24.5757 21.4778 24.5757 21.1746C24.6034 19.3096 23.8108 17.8488 22.2626 16.9577C21.1107 16.2962 19.7191 16.1492 18.4382 16.5626C17.3692 16.9026 16.549 17.4997 15.9776 18.3633C15.5076 17.904 14.9639 17.5732 14.328 17.3619C14.1622 17.3068 13.9963 17.2609 13.8027 17.2149C13.6184 17.1782 13.4341 17.1414 13.2498 17.1139C12.9734 17.0771 12.7153 17.0679 12.3651 17.0863C12.3559 17.0863 12.2545 17.0863 12.2453 17.0863C11.3053 17.169 10.4391 17.5457 9.67418 18.198C8.35636 19.3188 7.77578 21.0828 8.15361 22.81C8.57753 24.7393 9.71104 26.3287 11.72 27.817C13.1577 28.8735 14.8718 29.7371 16.9545 30.4537C17.0374 30.4813 17.1296 30.4997 17.2217 30.4997C17.3692 30.4997 17.5166 30.4629 17.6456 30.3802C19.5348 29.2318 21.0185 28.0283 22.1336 26.7513L22.1244 26.7605ZM20.9632 25.6396C19.968 26.7788 18.7054 27.8262 17.1111 28.8184C15.3417 28.1845 13.8857 27.4311 12.6692 26.54C10.9644 25.2813 10.0612 24.0319 9.72026 22.4884C9.47144 21.3584 9.86771 20.164 10.7155 19.4382C11.2316 18.9972 11.7753 18.7584 12.402 18.7033H12.5034C12.6877 18.6941 12.872 18.7033 13.0471 18.7216C13.1853 18.74 13.3235 18.7676 13.4433 18.7951C13.5816 18.8319 13.7198 18.8686 13.8304 18.9054C14.5031 19.1351 15.0192 19.576 15.4523 20.3018C15.6182 20.5683 15.9039 20.7153 16.2264 20.6877C16.5398 20.651 16.7978 20.4396 16.8992 20.1457C17.2678 19.0707 17.8945 18.4368 18.9266 18.1061C19.7744 17.8305 20.696 17.9223 21.4517 18.3633C22.4838 18.9605 22.9814 19.87 22.963 21.1471C22.963 21.4043 22.9354 21.6432 22.9169 21.8453C22.8893 22.029 22.8524 22.2128 22.8156 22.3782C22.6405 23.1223 22.2995 23.8573 21.7834 24.6015C21.6728 24.7668 21.553 24.9322 21.4056 25.1068C21.2766 25.2813 21.1383 25.4467 21.037 25.5661C21.0185 25.5845 20.9909 25.6121 20.9632 25.6396Z"
        fill="#121112"
      />
      <path
        d="M43.1266 15.4693C43.0529 14.8171 42.6474 14.2658 42.0484 13.9994C41.4494 13.733 40.7675 13.7973 40.2238 14.1739L31.3584 20.3386C30.8055 20.7245 30.5106 21.3492 30.5751 22.0199C30.6304 22.6905 31.0358 23.2601 31.6441 23.5357L41.818 28.2304C42.0669 28.3499 42.3341 28.405 42.6014 28.405C42.9884 28.405 43.357 28.2856 43.6888 28.0467C44.2417 27.6516 44.5274 27.0085 44.4445 26.3287L43.1359 15.4785L43.1266 15.4693ZM42.7304 26.7329C42.7304 26.7329 42.6014 26.8064 42.4816 26.7605L32.3076 22.0658C32.197 22.0107 32.1694 21.9188 32.1694 21.8637C32.1694 21.7994 32.1694 21.7075 32.2707 21.6432L41.1361 15.4785C41.2375 15.405 41.3296 15.4326 41.3757 15.4602C41.4218 15.4785 41.5047 15.5337 41.5139 15.6531L42.8225 26.5032C42.841 26.6318 42.7672 26.6962 42.7212 26.7329H42.7304Z"
        fill="#121112"
      />
      <path
        d="M30.2341 29.8105L29.9669 29.8381C29.6627 29.8748 29.3771 29.9208 29.0822 29.9851L28.4002 23.6735C28.7781 23.5724 29.0361 23.2233 28.9992 22.8282L28.5108 18.3357C28.4647 17.9406 28.1422 17.6558 27.7459 17.6374L27.6538 16.7922C28.0316 16.6911 28.2896 16.342 28.2528 15.947L28.0685 14.2473C28.603 14.376 29.1651 14.4586 29.7365 14.4586C33.6254 14.4586 36.7956 11.2982 36.7956 7.42122C36.7956 3.5442 33.6254 0.383789 29.7365 0.383789C27.4418 0.383789 25.4144 1.48626 24.1242 3.17671C23.5897 2.97459 23.0183 2.87353 22.4193 2.93784L6.87267 4.60992C5.88661 4.72017 5.00192 5.19791 4.37526 5.96963C3.75782 6.74136 3.47213 7.70602 3.5735 8.68906L4.19095 14.3668C3.82232 14.477 3.5735 14.8169 3.61037 15.212L4.3384 21.8544C4.38447 22.2494 4.6978 22.5342 5.08486 22.5618L7.45325 44.3172C7.56384 45.3002 8.04305 46.1822 8.81716 46.8069C9.48068 47.3398 10.2916 47.6246 11.1395 47.6246C11.2777 47.6246 11.4067 47.6246 11.545 47.6062L27.0732 45.925C28.0592 45.8147 28.9439 45.337 29.5706 44.5653C30.1972 43.7935 30.4737 42.8289 30.3723 41.8458L29.8839 37.3624C30.1696 37.2522 30.4737 37.1603 30.787 37.1328C32.5564 36.9398 34.2244 38.0147 34.7682 39.696C35.0538 40.5688 35.9109 41.1292 36.8232 41.019L40.8504 40.5688C41.2559 40.5229 41.6245 40.3116 41.8549 39.99C42.0945 39.6684 42.1867 39.2642 42.113 38.8692C41.0624 33.072 35.9478 29.1858 30.2341 29.8289V29.8105ZM29.718 1.98237C32.7223 1.98237 35.1644 4.41699 35.1644 7.41203C35.1644 10.4071 32.7223 12.8417 29.718 12.8417C29.0637 12.8417 28.4371 12.7223 27.8565 12.511L27.7367 11.4452C27.6906 11.0502 27.3681 10.7746 26.9718 10.747L26.4834 6.21769C26.3912 5.36328 26.0042 4.6283 25.442 4.05869C26.4373 2.80003 27.9855 1.99156 29.7088 1.99156L29.718 1.98237ZM28.3081 43.5547C27.9579 43.9865 27.4602 44.2621 26.8981 44.3264L11.3699 46.0076C10.8169 46.072 10.264 45.9066 9.83087 45.5575C9.39774 45.2084 9.12127 44.7122 9.05676 44.1518L5.17701 8.5145C5.1125 7.95408 5.27838 7.41203 5.62857 6.98023C5.97877 6.54843 6.48562 6.27281 7.03855 6.2085L11.2408 5.75833L11.2777 6.05232C11.3422 6.62193 11.8583 7.04454 12.4389 6.98023L17.4982 6.429C18.0696 6.36469 18.4935 5.8502 18.429 5.2714L18.4013 4.97741L22.576 4.52724C22.8156 4.49967 23.046 4.52724 23.2671 4.57317C23.5344 4.63748 23.7832 4.74773 24.0044 4.89473C24.2532 5.06928 24.456 5.28978 24.6126 5.54702C24.7601 5.79508 24.8614 6.07069 24.8891 6.37387L25.4973 11.9873L25.6171 13.1173L27.4971 30.4077C23.046 31.9971 19.9403 36.3335 20.1246 41.2119C20.1431 41.6345 20.3366 42.0388 20.6499 42.3144C20.9356 42.5532 21.295 42.6911 21.6636 42.6911C21.7189 42.6911 21.7742 42.6911 21.8387 42.6819L26.1885 42.1949C26.9073 42.1123 27.451 41.5151 27.4602 40.8077C27.4602 39.8981 27.8012 39.0529 28.3634 38.4098L28.7596 42.0204C28.8241 42.5716 28.6583 43.1229 28.3081 43.5547ZM36.6389 39.402C36.4915 39.4112 36.344 39.3285 36.2979 39.1815C35.5146 36.7745 33.1186 35.2218 30.6027 35.5158C30.2894 35.5526 29.9945 35.6169 29.6996 35.6996C29.1375 35.8649 28.6214 36.1222 28.1606 36.4437C26.8151 37.3716 25.9212 38.8875 25.8659 40.6055L21.7466 41.0649C21.636 37.0593 24.1058 33.4946 27.6906 32.043C28.1975 31.8409 28.7135 31.6755 29.2573 31.5561C29.5522 31.4918 29.8471 31.4459 30.1512 31.4091L30.4184 31.3816C35.2197 30.8395 39.5326 34.0826 40.5002 38.9427L36.6389 39.3745V39.402Z"
        fill="#121112"
      />
    </g>
    <defs>
      <clipPath id="clip0_4741_15755">
        <rect
          fill="white"
          height="47.25"
          transform="translate(3.55518 0.375)"
          width="40.8894"
        />
      </clipPath>
    </defs>
  </svg>
)

export default BabyPhoneDark
